import { useRoutes, Navigate } from "react-router-dom";
import AuthGuard from "../auth/AuthGuard";
import HomePage from "../pages/HomePage";
import SearchResultsPage from "../pages/SearchResultsPage";
import BookingPage from "../pages/BookingPage";
import PaymentPage from "../pages/PaymentPage";
import MobileCheckoutPage from "../pages/MobileCheckoutPage";
import ConfirmationPage from "../pages/ConfirmationPage";
import MyTicketsPage from "../pages/MyTicketsPage";
import TermsPage from "../pages/TermsPage";
import PrivacyPage from "../pages/PrivacyPage";
import AccountDeletionPage from "../pages/AccountDeletionPage";
import ArrivalsPage from "../pages/ArrivalsPage";
import ClaimTicketPage from "../pages/ClaimTicketPage";
import HelpCenterPage from "../pages/HelpCenterPage";
import SettingsPage from "../pages/SettingsPage";
import OnlineSmokeTestPage from "../pages/OnlineSmokeTestPage";

const IS_DEV = process.env.NODE_ENV === "development";

export default function Router() {
    return useRoutes([
        {
            path: "/",
            element: <HomePage />,
        },
        {
            path: "/rezultati",
            element: <SearchResultsPage />,
        },
        {
            // Kupovina zahteva prijavu pravim nalogom (ne gost).
            path: "/rezervacija",
            element: (
                <AuthGuard>
                    <BookingPage />
                </AuthGuard>
            ),
        },
        {
            path: "/placanje",
            element: <PaymentPage />,
        },
        {
            // WebView ulaz iz mobilne aplikacije — rekonstruiše stanje iz /status
            path: "/placanje/m/:merchantPaymentId",
            element: <MobileCheckoutPage />,
        },
        {
            path: "/potvrda",
            element: <ConfirmationPage />,
        },
        {
            path: "/moje-karte",
            element: (
                <AuthGuard>
                    <MyTicketsPage />
                </AuthGuard>
            ),
        },
        {
            path: "/dolasci",
            element: <ArrivalsPage />,
        },
        {
            // Digitalna kopija karte sa slipa (QR) — javno, pristup čuva token u linku.
            path: "/k/:token",
            element: <ClaimTicketPage />,
        },
        {
            path: "/uslovi-kupovine",
            element: <TermsPage />,
        },
        {
            path: "/politika-privatnosti",
            element: <PrivacyPage />,
        },
        {
            path: "/brisanje-naloga",
            element: <AccountDeletionPage />,
        },
        {
            path: "/pomoc",
            element: <HelpCenterPage />,
        },
        {
            path: "/podesavanja",
            element: <SettingsPage />,
        },
        ...(IS_DEV
            ? [{ path: "/test/online", element: <OnlineSmokeTestPage /> }]
            : []),
        {
            path: "/login",
            element: <Navigate to="/" replace />,
        },
        {
            path: "/register",
            element: <Navigate to="/" replace />,
        },
    ]);
}
